import React, { FC } from 'react';

import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MobileSdkTestAllIssues } from './all-issues/MobileSdkTestAllIssues';
import { MobileSdkSessionOverview } from './overview/MobileSdkSessionOverview';

interface IMobileSdkSingleTestTabContentProps {
	viewId: SessionViews;
	testId: string;
}

export const MobileSdkSingleTestTabContent: FC<IMobileSdkSingleTestTabContentProps> = ({
	viewId,
	testId
}) => {
	switch (viewId) {
		case SessionViews.OVERVIEW: {
			return <MobileSdkSessionOverview testId={testId} />;
		}

		case SessionViews.ALL_ISSUES: {
			return <MobileSdkTestAllIssues testId={testId} />;
		}

		default:
			return null;
	}
};
